// extracted by mini-css-extract-plugin
module.exports = {"root":"FairPremiumPhones_root__3vS6X","grid":"FairPremiumPhones_grid__1vmjS","phone":"FairPremiumPhones_phone__1euCf"};